import React from 'react';
import './PetAnimations.css';

export default function JellyfishBloomSvg({ size = 120, color, className = '' }) {
  const bell = color || '#F2C6E2';
  const bellLight = '#FFE4F2';
  const bellDeep = '#C497CC';
  const lavender = '#D4BAE8';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Soft glow halo */}
      <circle cx="60" cy="48" r="44" fill={bell} opacity="0.12" />
      <circle cx="60" cy="48" r="32" fill={bellLight} opacity="0.18" />

      {/* Trailing tentacles (back layer, longest) */}
      <path d="M34 50C30 70 36 90 30 110" stroke={lavender} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.5" />
      <path d="M44 56C46 76 40 96 46 110" stroke={lavender} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6" />
      <path d="M76 56C74 76 80 96 74 110" stroke={lavender} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6" />
      <path d="M86 50C90 70 84 90 90 110" stroke={lavender} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.5" />
      {/* Frilly inner tentacles */}
      <path d="M48 58C50 70 46 82 50 92" stroke={bell} strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M56 60C54 74 58 86 54 96" stroke={bell} strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M64 60C66 74 62 86 66 96" stroke={bell} strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M72 58C70 70 74 82 70 92" stroke={bell} strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
      {/* Center oral arms */}
      <path d="M58 60C56 74 60 84 60 92" stroke={bellDeep} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M62 60C64 74 60 84 60 92" stroke={bellDeep} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.7" />

      {/* Bell (translucent dome) */}
      <path d="M22 50C22 28 42 14 60 14C78 14 98 28 98 50C98 56 94 60 88 60L32 60C26 60 22 56 22 50Z" fill={bell} opacity="0.85" />
      {/* Bell highlight */}
      <path d="M30 42C32 30 44 22 56 22" stroke={bellLight} strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
      {/* Bell inner ring */}
      <ellipse cx="60" cy="48" rx="30" ry="14" fill={bellLight} opacity="0.3" />
      {/* Frilled bell edge */}
      <path
        d="M22 50C26 52 28 56 32 56C36 56 38 52 42 54C46 56 48 52 52 54C56 56 58 52 62 54C66 56 68 52 72 54C76 56 78 52 82 56C86 56 88 52 92 54C96 54 98 52 98 50"
        stroke={bellDeep}
        strokeWidth="1.2"
        fill="none"
        opacity="0.7"
      />
      {/* Inner organs (decorative) */}
      <ellipse cx="46" cy="44" rx="4" ry="6" fill={lavender} opacity="0.5" />
      <ellipse cx="60" cy="42" rx="4" ry="6" fill={lavender} opacity="0.5" />
      <ellipse cx="74" cy="44" rx="4" ry="6" fill={lavender} opacity="0.5" />
      {/* Cute face */}
      <ellipse cx="52" cy="40" rx="2" ry="2.5" fill="#2C2419" />
      <ellipse cx="68" cy="40" rx="2" ry="2.5" fill="#2C2419" />
      <circle cx="52.5" cy="39" r="0.7" fill="white" />
      <circle cx="68.5" cy="39" r="0.7" fill="white" />
      <path d="M56 46C58 48 62 48 64 46" stroke={bellDeep} strokeWidth="0.9" strokeLinecap="round" fill="none" />
      {/* Cheek blush */}
      <circle cx="46" cy="46" r="2.5" fill="#F8A0C8" opacity="0.5" />
      <circle cx="74" cy="46" r="2.5" fill="#F8A0C8" opacity="0.5" />
      {/* Sparkles */}
      <path d="M14 36L15 34L16 36L15 38Z" fill="white" opacity="0.6" />
      <path d="M104 38L105 36L106 38L105 40Z" fill="white" opacity="0.6" />
    </svg>
  );
}
